module.exports = __webpack_public_path__ + "static/media/AnimalBanner.5aae90b8.svg";